import emailValidator from 'email-validator';
import { Utilities } from 's2s-app-service';
import { initialState as localeInitialState } from "../hooks/locale";
import { initialState as authInitialState } from "../hooks/auth";
import { initialState as callInfoInitialState } from "../hooks/callInfo";
import { initialState as alertsInitialState } from "../hooks/alerts";
//import { initialState as contactsInitialState } from "../hooks/contacts";
import { initialState as settingsInitialState } from '../hooks/settings';

export const getStoreInitialValue = () => {
  return {
    "auth": authInitialState,
    "locale": localeInitialState,
    "callInfo": callInfoInitialState,
    "alerts": alertsInitialState,
    "settings": settingsInitialState,
  };
};

export const getIntlText = (intl = undefined, keyName = "", defaultMsg = "no default msg") => {

  let sMessage = defaultMsg;
  if (intl) {
    const intlMsg = intl.formatMessage({ "id": keyName });
    if (intlMsg !== keyName) {
      sMessage = intlMsg;
    }
  }

  return sMessage;
};

export const extractContactNameFromContactArray = (number, contacts) => {
  if (number && number.slice && contacts && Array.isArray(contacts)) {
    // Need to remove leading '+1'.  This will have to be modified as new
    // international number formats are utilized
    const numToMatch = number.length === 11 ? number.slice(1) : number;
    const myContact = contacts.find(contact =>
        (contact.phone_numbers || []).some(numberItem => numberItem.number === numToMatch));

    return myContact ? Utilities.getContactName(myContact) : numToMatch;
  }
};

export const extractQueryParamValues = (paramString) => {
  // Expect paramString to have format:
  // "?event_uuid=1234&list_uuid=4567&appointee_uuid=9876&.....""
  let retValue = {};

  let paramArray = paramString.split("&");
  // if first item has '?' as first char, remove it
  if (paramArray[0].charAt(0) === "?") {
    paramArray[0] = paramArray[0].slice(1);
  }

  paramArray.forEach((item) => {
    const itemSplit = item.split("=");
    retValue[itemSplit[0]] = itemSplit[1];
  });
  return retValue;
};

export const validateEmail = (email) => {
  return emailValidator.validate(email);
};

// NOTE: Temporary validation based on email/username length until we receive further instruction
export const validateUserName = (username) => {
  return username !== undefined && username.length > 3;
};

// NOTE: Temporary validation based on password length until we receive further instruction
export const validatePassword = (password) => {
  return password !== undefined && password.length > 3;
};

export const phoneNumberValidation = (number) => {
  return number !== undefined && Utilities.cleanPhoneNumber(number);
};

export const startRecording = (id) => {
  navigator.getUserMedia({
    audio: true,
    video: false
  }, function (audioinputstream) {
    const audioContext = new AudioContext();
    // getting all video tags
    var myElement = document.getElementById(id);
    // get the last one .. we have 2 .... hack for now
    if (myElement === null) {
      throw new Error("session element not found to start recording: " + id);
    }

    var input = audioContext.createMediaStreamSource(audioinputstream);
    var video = audioContext.createMediaStreamSource(myElement.captureStream());

    // merger
    var merger = audioContext.createChannelMerger(2);

    input.connect(merger, 0, 1);
    video.connect(merger, 0, 0);

    var dest = audioContext.createMediaStreamDestination();

    merger.connect(dest);
    //eslint-disable-next-line no-undef
    window.rec = new Recorder(dest);

    window.rec.record();
  }, function (error) {
    console.log('>>>>>', error);
    throw new Error("error getting user media during start recording");
  });
};

export const stopRecording = (id) => {
  window.rec.stop();
  // stopping
  window.rec.exportWAV(function (blob) {
    //console.log('aaaa', blob);
    const a = document.createElement("a");
    a.style = "display: none";

    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = Date.now() + ".wav";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    setTimeout(() => {
      window.rec = undefined;
    }, 2000); //just cleaning up window.rec
  });
};


export const processServiceErrorsToAlerts = (e) => {

  // console.log('e.message', e.message);
  // This function handles conversion of error codes from appService and CallService
  // to alert heading and body strings.  

  // since e.message is a string, need to JSON.parse to get object data

  // We can get a few different types here... Error object (expected), object or string

  console.log('EEEEEEEEE', typeof (e), e, typeof (e.message), e.message);

  const errorObj = e;
  let alertHeading = "";
  let alertBody = "";

  // switch on errorObj.statusCode to determine what alert content should be
  switch (errorObj.code) {
    case 400: 
      alertHeading = Utilities.getInstance().getIntlMessage( 'CALL-SERVICE-ERROR-BAD-REQUEST', "Bad Request");
      alertBody = `Call Service received a bad request: ${errorObj.message}`;
      break;
    
    case 401: 
      alertHeading = Utilities.getInstance().getIntlMessage( 'CALL-SERVICE-ERROR-UNAUTHORIZED', "Unauthorized");
      alertBody = `Call Service received an unauthorized request: ${errorObj.message}`;
    break;

    case 403:
      alertHeading = Utilities.getInstance().getIntlMessage( 'CALL-SERVICE-ERROR-FORBIDDEN', "Forbidden");
      alertBody = `Call Service received request that is not allowed: ${errorObj.message}`;
      break;

    case 500:
      alertHeading = Utilities.getInstance().getIntlMessage( 'CALL-SERVICE-GENERAL-ERROR-HEADING', "Call Service Error");
      alertBody = `Call Service detected and internal error: ${errorObj.message}`;
      break;

    case 503:
      alertHeading = Utilities.getInstance().getIntlMessage( 'CALL-SERVICE-ERROR-UNAVAILABLE', "Unavailable");
      alertBody = `Call Service received request for a service that is unavailable: ${errorObj.message}`;
      break;

    case 1001: // Missing token for change pwd
      alertHeading = Utilities.getInstance().getIntlMessage( 'CHANGE-PWD-ERROR-HEADING', "Change Password Error");
      alertBody = Utilities.getInstance().getIntlMessage( 'CHANGE-PWD-MISSING-TOKEN', "Missing token for change password.  Please retry 'Forgot password'.");
      break;

    case 1002: // New password cannot match previous password
      alertHeading = Utilities.getInstance().getIntlMessage( 'CHANGE-PWD-ERROR-HEADING', "Change Password Error");
      alertBody = Utilities.getInstance().getIntlMessage( 'CHANGE-PWD-CANNOT-MATCH-PREVIOUS', "New password cannot match previous password.  Please try again with a different password.");
      break;

    case 1003: // New password does not meet required criteria
      alertHeading = Utilities.getInstance().getIntlMessage( 'CHANGE-PWD-ERROR-HEADING', "Change Password Error");
      alertBody = Utilities.getInstance().getIntlMessage( 'CHANGE-PWD-DOES-NOT-MEET-CRITERIA', "Password should contain at least one letter, at least one number, no white space, not start with @, and 8 or more characters.");
      break;

    case 1004: // Other password error 
      alertHeading = Utilities.getInstance().getIntlMessage( 'CHANGE-PWD-ERROR-HEADING', "Change Password Error");
      alertBody = Utilities.getInstance().getIntlMessage( 'CHANGE-PWD-GENERAL-ERROR', "Error changing password.Please try again.  If error persists, contact Technical Suport");
      break;

    default:
      alertHeading = Utilities.getInstance().getIntlMessage( 'CALL-SERVICE-GENERAL-ERROR-HEADING', "Call Service Error");
      alertBody = `${Utilities.getInstance().getIntlMessage( 'CALL-SERVICE-GENERAL-ERROR', "Call service reported error")} ${errorObj.code}. ${Utilities.getInstance().getIntlMessage( 'CALL-SERVICE-RETRY-CONTACT-TECH-SUPPORT', "Please try again.  If error persists contact Technical Support.")}`;
  }

  return {
    "alertHeading": alertHeading,
    "alertBody": alertBody
  };



};

/** Method that returns either value localed in sourceObject by path or defaultValue.
 *
 * @param defaultValue { any }      - Default returned value.
 * @param path         { string[] } - Path to value inside sourceObject.
 * @param sourceObject { Object }   - Source object.
 */
export const pathOr = (defaultValue, path, sourceObject) => {
  const safeSourceObject = sourceObject || {};
  const safePath = path || [];
  let fieldValue;

  for (fieldValue = safeSourceObject[safePath.shift()];
       !!safePath.length && (typeof fieldValue !== 'undefined');
       fieldValue = fieldValue[safePath.shift()]);

  return safePath.length ? defaultValue : fieldValue;
};

export const debounce = (func, delay, head) => {
  let timeout;

  return function() {
    const context = this, args = arguments;
    const later = function() {
      timeout = null;
      if (!head) func.apply(context, args);
    };

    const callNow = head && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, delay);

    if (callNow) {
      func.apply(context, args);
    }
  };
};


/** This code fixes the issue with input cursor in electron:
 * when user starts selecting text in input and moves mouse outside electron viewport, then
 * types further - cursor freezes on 0 position.
 */
(function() {
  /** This methods creates closure of parameters which allows to detect the situation when bug is
   * going to be reproduced (i.e. input mousedown > document mouseleave (without mouseup before) > input keydown)
   * and returns set of event handlers required to detect this situation.
   */
  const registerInputFocusFix = () => {
    let needToFocusInput = false;
    let mouseIsDown = false;
    let inputSelectionStart = 0;
    let leaveTarget = null;
    const documentMouseLeave = function() {
      if (leaveTarget) {
        const { selectionStart } = leaveTarget;
        inputSelectionStart = selectionStart;

        if (mouseIsDown) {
          needToFocusInput = true;
        }
      } else {
        inputSelectionStart = 0;
      }
    };

    document.addEventListener('mouseleave', documentMouseLeave);

    return {
      mouseleave: function(e) {
        leaveTarget = e.target;
      },
      keydown: function(e) {
        if (needToFocusInput) {
          const { x, y } = e.target.getBoundingClientRect();
          window.focusInputFix({
            x: x + 10,
            y: y + 10,
          });
          needToFocusInput = false;
          mouseIsDown = false;

          setTimeout(() => {
            e.target.selectionStart = inputSelectionStart + 1;
          });
        }
      },
      mouseup: function() {
        needToFocusInput = false;
        mouseIsDown = false;
      },
      mousedown: function() {
        mouseIsDown = true;
      },
      documentMouseLeave,
    };
  };
  

  if (window.focusInputFix) {
    // Collection for timely invocation of removeEventListeners.
    const inputFixHandlerCollection = new Map();

    // This code looks for new input elements in DOM and adds event handlers to them.
    document.addEventListener('DOMNodeInserted', ({ srcElement }) => {
      setTimeout(() => {
        if (srcElement && srcElement.tagName && srcElement.tagName !== 'SCRIPT') {
          const inputElements = document.querySelectorAll('input');

          [...inputElements].filter(inputElement =>
              !inputFixHandlerCollection.has(inputElement)).forEach(inputElement => {
            const focusFixHandlers = registerInputFocusFix();

            ['mousedown', 'mouseup', 'keydown', 'mouseleave'].forEach(eventType => {
              inputElement.addEventListener(eventType, focusFixHandlers[eventType]);
            });

            inputFixHandlerCollection.set(inputElement, focusFixHandlers);
          });
        }
      });
    });

    // This code looks detached input elements from DOM and invokes removeEventListener for them.
    document.addEventListener('DOMNodeRemoved', ({ srcElement }) => {
      setTimeout(() => {
        if (srcElement && srcElement.tagName && srcElement.tagName !== 'SCRIPT') {
          [...inputFixHandlerCollection.keys()].forEach(inputElement => {
            if (!inputElement.isConnected) {
              const focusFixHandlers = inputFixHandlerCollection.get(inputElement);

              ['mousedown', 'mouseup', 'keydown', 'mouseleave'].forEach(eventType => {
                inputElement.removeEventListener(eventType, focusFixHandlers[eventType]);
              });

              document.removeEventListener('mouseleave', focusFixHandlers['documentMouseLeave']);

              inputFixHandlerCollection.delete(inputElement);
            }
          });
        }
      });
    });
  }
})();
